var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoodonnee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5H6V12H10.5V10.5Z",
    fill: "#1956A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5H6V6H15V4.5Z",
    fill: "#1956A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5H6V9H15V7.5Z",
    fill: "#1956A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18H6V19.5H10.5V18Z",
    fill: "#1956A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 18.75H15.75C15.1533 18.75 14.581 18.9871 14.159 19.409C13.7371 19.831 13.5 20.4033 13.5 21V22.5H15V21C15 20.8011 15.079 20.6103 15.2197 20.4697C15.3603 20.329 15.5511 20.25 15.75 20.25H20.25C20.4489 20.25 20.6397 20.329 20.7803 20.4697C20.921 20.6103 21 20.8011 21 21V22.5H22.5V21C22.5 20.4033 22.2629 19.831 21.841 19.409C21.419 18.9871 20.8467 18.75 20.25 18.75Z",
    fill: "#1956A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18C18.5933 18 19.1734 17.8241 19.6667 17.4944C20.1601 17.1648 20.5446 16.6962 20.7716 16.1481C20.9987 15.5999 21.0581 14.9967 20.9424 14.4147C20.8266 13.8328 20.5409 13.2982 20.1213 12.8787C19.7018 12.4591 19.1672 12.1734 18.5853 12.0576C18.0033 11.9419 17.4001 12.0013 16.8519 12.2284C16.3038 12.4554 15.8352 12.8399 15.5056 13.3333C15.1759 13.8266 15 14.4067 15 15C15 15.7956 15.3161 16.5587 15.8787 17.1213C16.4413 17.6839 17.2044 18 18 18ZM18 13.5C18.2967 13.5 18.5867 13.588 18.8334 13.7528C19.08 13.9176 19.2723 14.1519 19.3858 14.426C19.4994 14.7001 19.5291 15.0017 19.4712 15.2926C19.4133 15.5836 19.2704 15.8509 19.0607 16.0607C18.8509 16.2704 18.5836 16.4133 18.2926 16.4712C18.0017 16.5291 17.7001 16.4994 17.426 16.3858C17.1519 16.2723 16.9176 16.08 16.7528 15.8334C16.588 15.5867 16.5 15.2967 16.5 15C16.5 14.6022 16.658 14.2206 16.9393 13.9393C17.2206 13.658 17.6022 13.5 18 13.5Z",
    fill: "#1956A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22.5H4.5C4.1023 22.4996 3.72101 22.3414 3.4398 22.0602C3.15859 21.779 3.00042 21.3977 3 21V3C3.00042 2.6023 3.15859 2.22101 3.4398 1.9398C3.72101 1.65859 4.1023 1.50042 4.5 1.5H16.5C16.8977 1.50042 17.279 1.65859 17.5602 1.9398C17.8414 2.22101 17.9996 2.6023 18 3V10.5H16.5V3H4.5V21H10.5V22.5Z",
    fill: "#1956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoodonnee);
export default __webpack_public_path__ + "static/media/icon_coodonnee.1e9d6970aa4cf4722b68403963b23202.svg";
export { ForwardRef as ReactComponent };